export const pagesTimeAndAttendanceEn = {
  pageTitle: "Time & Attendance",
  tabs: {
    attendances: "Attendances",
    attendanceLinks: "Attendance Settings",
  },
  attendances: {
    toCurrentDate: "To current date",
    toCurrentMonth: "To current month",
    dailyPlace: {
      pageTitle: "Attendances",
      searchPlaceholder: "Search by member name",
      closeAttendance: "Close Attendance",
    },
    monthlyPerson: {
      pageTitle: "Attendances",
      summary: {
        totalHours: "Total hours",
        daysWorked: "Days worked",
        daysErrored: "Days errored",
        daysUnit: "days",
      },
    },
    monthlyPlace: {
      pageTitle: "Attendances",
      searchPlaceholder: "Search by member name",
      summary: {
        errorDayCount: "Error days",
        errorWorkerCount: "Error workers",
        daysUnit: "days",
        workersUnit: "workers",
      },
    },
    updateDialog: {
      updateClockIn: "Update Clock In",
      updateClockOut: "Update Clock Out",
      updateBreakTime: "Update Break Time",
      clockInTime: "Clock In",
      clockOutTime: "Clock Out",
      breakTime: "Break Time",
      personName: "Person Name",
      currentTime: "Current Time",
      reason: "Reason",
      reasonPlaceholder: "Reason",
      save: "Save",
      updateBreakTimeSuccess: "Break time updated successfully",
      updateClockInSuccess: "Clock in updated successfully",
      updateClockOutSuccess: "Clock out updated successfully",
      validation: {
        invalidTimeFormat: "Invalid time format",
        startTimeMustBeBeforeEndTime: "Start time must be before end time",
        overTimeLimit: "Time over 28:00 is not allowed",
      },
    },
    summaryUnit: {
      daily: "Day",
      monthly: "Month",
    },
    timeFormat: {
      hourUnit: "h",
      minuteUnit: "m",
    },
    editedRecord: "Edited Record",
    editReason: "Reason",
  },
  attendanceLinks: {
    redirect: {
      noLocation: "No attendance location found",
      redirecting: "Redirecting to attendance page...",
    },
    pageTitle: "Attendance Links",
    title: "Clocking In/Out – {{placeName}}",
    description:
      "The store attendance manager will have part-time employees manage their daily attendance.",
    place: "Place",
    qrCode: {
      printTimestampSheet: "Print QR timestamps sheet",
      pdf: "PDF",
    },
    form: {
      frequency: "Frequency",
      validityPeriod: "Validity Period",
      validityPeriodPlaceholder: "Select...",
      invalid: "(Expired)",
      replaceDialog: {
        title: "Are you sure you want to replace?",
        description:
          "The link URL will be changed. This action cannot be undone.",
        cancelButton: "Cancel",
        replaceButton: "Replace",
      },
      deleteDialog: {
        title: "Are you sure you want to delete?",
        description:
          "The attendance link will be permanently removed. This action cannot be undone.",
        cancelButton: "Cancel",
        deleteButton: "Delete",
      },
      notice: "Notice",
      noticePlaceholder: "Enter notice text here...",
      buttons: {
        publish: "Publish",
        publishing: "Publishing...",
        save: "Save",
        saving: "Saving...",
        replace: "Replace Link",
        replacing: "Replacing...",
        delete: "Delete",
        deleting: "Deleting...",
        cancel: "Cancel",
        print: "Print",
      },
      options: {
        daily: "Daily",
        weekly: "Weekly",
      },
      messages: {
        success: {
          published: "Attendance link published successfully",
          updated: "Attendance link updated successfully",
          replaced: "Attendance link replaced successfully",
          deleted: "Link deleted successfully",
        },
        error: {
          default: "An error occurred",
          validation: "Validation error",
          publish: "Failed to publish attendance link",
          update: "Failed to update attendance link",
          replace: "Failed to replace attendance link",
          delete: "Failed to delete link",
        },
      },
    },
  },
};
